/** @flow */
import EventEmitter from "wolfy87-eventemitter";

class NotificationCenter extends EventEmitter {}

export default new NotificationCenter();
